module.exports = __webpack_public_path__ + "img/1@3x.85a57619.png";